import { useFormik } from "formik";
import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { getApiCaller } from "../../libs/apiCaller";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const profileInfo = useSelector((state) => state?.profile?.data);

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
        .required("New password is required")
        .notOneOf(
          [Yup.ref("oldPassword")],
          "New password cannot be the same as old password"
        )
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_^])[A-Za-z\d@$!%*?&_^]{8,}$/,
          "Password must have at least 1 uppercase, 1 lowercase, 1 number, and 1 special character"
        ),
      confirmPassword: Yup.string()
        .required("Confirm password is required")
        .oneOf(
          [Yup.ref("newPassword")],
          "New password and confirm password do not match"
        ),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const endPoint = `change_password?user_name=${profileInfo?.name}&email=${profileInfo?.email}&password=${values.oldPassword}&new_password=${values.newPassword}`;
        const response = await getApiCaller(endPoint);
        if (response?.data.response_code === 200) {
          toast.success(response.data.response_message);
          resetForm();
          setSubmitting(false);
          navigate("/dashboard");
        } else {
          toast.error(response?.data?.response_message);
        }
      } catch (error) {
        console.log("error", error);
        toast.error(error?.message);
        setSubmitting(false);
      }
    },
  });

  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <div className="flex justify-center items-center min-h-[78vh] bg-gray-100 p-4">
      <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Change Password
        </h2>

        <form onSubmit={formik.handleSubmit}>
          {["oldPassword", "newPassword", "confirmPassword"].map((field) => (
            <div key={field} className="mb-4 relative">
              <label class="block mb-2 text-sm font-medium text-gray-700">
                {field === "oldPassword"
                  ? "Old Password"
                  : field === "newPassword"
                  ? "New Password"
                  : "Confirm Password"}
              </label>
              <div class="relative">
                <div class="absolute inset-y-0 end-3 top-0 flex items-center ps-3.5">
                  <button
                    type="button"
                    className=" flex items-center text-gray-500"
                    onClick={() => togglePasswordVisibility(field)}
                  >
                    {!showPassword[field] ? (
                      <AiOutlineEyeInvisible size={20} />
                    ) : (
                      <AiOutlineEye size={20} />
                    )}
                  </button>
                </div>
                <input
                  type={showPassword[field] ? "text" : "password"}
                  id="phone-input"
                  className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                  {...formik.getFieldProps(field)}
                />
              </div>
              {formik.errors[field] && formik.touched[field] && (
                <p className="text-red-500 text-sm mb-3">
                  {formik.errors[field]}
                </p>
              )}
            </div>
          ))}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? "Loading..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
